import { useTranslation } from 'react-i18next';
import { MessageSquare } from 'lucide-react';
import { IconButton } from '@/shared/ui/IconButton';
import { useAuthStore } from '@/entities/session/model/authStore';
import { selectUnreadTotal, useChatStore } from '../model/chatStore';

/** Başlıktaki sohbet düğmesi + okunmamış rozeti. Sohbet yetkisi yoksa çizilmez. */
export function ChatHeaderButton() {
  const { t } = useTranslation();
  const canUseChat = useAuthStore((s) => !!s.user?.canUseChat);
  const unread = useChatStore(selectUnreadTotal);
  const open = useChatStore((s) => s.open);
  const setOpen = useChatStore((s) => s.setOpen);
  if (!canUseChat) return null;
  return (
    <span className="relative">
      <IconButton label={t('chat.title')} onClick={() => setOpen(!open)} aria-pressed={open}>
        <MessageSquare className="h-5 w-5" />
      </IconButton>
      {unread > 0 ? (
        <span className="bg-danger pointer-events-none absolute -top-0.5 -right-0.5 min-w-4 rounded-full px-1 text-center text-[10px] leading-4 font-semibold text-white tabular-nums">
          {unread > 99 ? '99+' : unread}
        </span>
      ) : null}
    </span>
  );
}
